<div class="container-fluid justify-content-center h-100 d-flex flex-column">
    <div class="row justify-content-center px-4">
        <mat-card class="login-card col-12 col-md-8 col-lg-6 col-xl-5 p-5">
            <mat-card-content class="d-flex flex-column">
                <h1 class="mb-2 title">{{'general.app_name' | translate}}​</h1>
                <ng-container>
                        <hr class="my-4" role="separator" />
                        <div class="provider-button-container">
                            @for (provider of providers(); track provider.label) {
                                <button mat-raised-button class="align-self-stretch mb-4 connect-button" color="primary"
                                    (click)="loginWithOAuth2(provider.url)"
                                >
                                    <mat-icon>arrow_right</mat-icon>
                                    {{'pages.login.connect_via' | translate: {provider: provider.label} }}
                                </button>
                            }
                        </div>
                    </ng-container>
            </mat-card-content>
        </mat-card>
    </div>
</div>

